export enum Event {
  sent = 'sent',
  received = 'received',
  both = 'both',
}
